import Modal from "../../../../../commons/Modal/Modal"
import { ModalProps, ModalSizes } from "../../../../../commons/Modal/Modal.types"
import Button from "../../../../../designSystem/Button/Button";
import { useDropzone } from "react-dropzone";
import { ButtonColor } from "../../../../../designSystem/Button/Button.types";
import { useCallback, useContext, useState } from "react";
import { DashboardProspectsDIRContext } from "../DashboardProspectsDIR.context";
import Select from "../../../../../commons/Select/Select";
import { SelectOption } from "../../../../../commons/Select/Select.types";
import { useMutation, useQueryClient } from "react-query";
import { UPLOAD_KOMPASS_QUERY_KEY, queryUploadExcelKompass } from "./UploadExcelModal.query";

export default (props: ModalProps) => {

  const queryClient = useQueryClient()

  const [commercialId, setCommercialId] = useState<number>()

  const { commerciaux } = useContext(DashboardProspectsDIRContext);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: {
      'text/csv': ['.csv'],
    },
  });

  const { mutate } = useMutation<Awaited<any>, Error, FormData>(
    (data) => queryUploadExcelKompass(data),
    {
      mutationKey: UPLOAD_KOMPASS_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: async (response) => {
        console.log('response', response)
      },
      onError: async (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = useCallback(() => {
    const formData = new FormData();
    const [file] = acceptedFiles
    formData.append('files', file);
    formData.append('commercialId', commercialId?.toString() || '0')
    // for (const file of acceptedFiles) {
    //   formData.append('files', file);
    // }
    mutate(formData);
  }, [acceptedFiles, commercialId]);

  return (
    <Modal
      size={ModalSizes.Small}
      closeOnClickOutside
      {...props}
    >
      <form className="form" style={{ width: '100%' }}>
        <div {...getRootProps({ className: 'dropzone register__dropzone' })}>
          <input {...getInputProps()} />
          <p>
            Glissez un fichier KOMPASS ici
          </p>
          {acceptedFiles.length > 0 && <span>{acceptedFiles[0].name}</span>}
        </div>
        <Select 
          placeholder="Selectionner un commercial..."
          options={commerciaux?.map(({ id, firstName, lastName }) => ({
            label: `${firstName} ${lastName}`,
            value: id.toString(),
          }))}
          // @ts-ignore
          onChange={({ value }: SelectOption) => {
            setCommercialId(parseInt(value))
          }}
        />
        <Button
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          style={{
            marginTop: 'var(--spacing-sToM)'
          }}
          color={ButtonColor.Excel}
          disabled={acceptedFiles.length === 0 || !commercialId}>
          Soumettre
        </Button>
      </form>
    </Modal>
  )
}